module.exports = __webpack_public_path__ + "static/media/striped_end_bar_tall.c3d1de7a.svg";